import { render } from "./SuperSearch.vue?vue&type=template&id=33e96f1d&scoped=true"
import script from "./SuperSearch.vue?vue&type=script&lang=js"
export * from "./SuperSearch.vue?vue&type=script&lang=js"

import "./SuperSearch.vue?vue&type=style&index=0&id=33e96f1d&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e96f1d"]])

export default __exports__